// extracted by mini-css-extract-plugin
module.exports =  {"buttons":"buttons__dgu-H","errorMessage":"errorMessage__H7-Cb"};